import type { LifecycleContextOptions } from '@cli-types/next-adapter/generators.js'
import { renderLifecycleContextContentTemplate } from '@next-adapter/templates/renderers/generators/actions/lifecycle-hook-emissions/lifecycle-context.js'
export function lifecycleContext(
  entityType: string,
  extras: string,
  options: LifecycleContextOptions = {}
): string {
  const userExpression = options.userExpression ?? 'actor'
  const sourceType = options.sourceType ?? 'admin_ui'
  const schemaType = options.schemaType
    ? `\n      schemaType: '${options.schemaType}' as const,`
    : ''

  return renderLifecycleContextContentTemplate({
    userExpression: userExpression,
    entityType: entityType,
    schemaType: schemaType,
    sourceType: sourceType,
    extras: extras
  })
}
